import { createFileRoute, Navigate, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/p/$ref")({
  component: RefPage,
});

function RefPage() {
  const { ref } = useParams({
    from: "/p/$ref",
  });
  return <Navigate to="/login" search={{ ref: ref }} />;
}
